const ClosingTime = [
	'[Verse 1]',
	'Closing time,',
	'Open all the doors',
	'and let you out into the world',
	'Closing time,',
	'Turn all of the lights on',
	'over every boy and every girl',
	'Closing time,',
	'One last call for alcohol',
	'so finish your whiskey or beer',
	'Closing time,',
	"You don't have to go home",
	"but you can't stay here",
	'',
	'[Chorus]',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'Take me home',
	'',
	'[Verse 2]',
	'Closing time,',
	'Time for you to go out',
	'to the places you will be from',
	'Closing time,',
	"This room won't be open",
	'till your brothers or your sisters Come',
	'So gather up your jackets move it to the exits',
	'I hope you have found a friend',
	'Closing time,',
	'Every new beginning',
	"comes from some other beginning's end, yeah",
	'',
	'[Chorus]',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'Take me home',
	'',
	'[Bridge]',
	'Closing time,',
	'(Hold)',
	'Time for you to go out',
	'to the places you will be from',
	'',
	'[Chorus]',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'I know who I want to take me home',
	'Take me home',
	'',
	'Closing time,',
	'Every new beginning',
	"comes from some other beginning's end",
];

export default ClosingTime;
